<lg-navbar-main />
<div class="main-and-footer-container">
  <div class="container" style="flex-grow: 1">
    <router-outlet />
  </div>
  <lg-footer />
</div>
